import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Langs, { Localize } from '../../app/lang/langs';
import { getTeamsManagersList } from '../../components/permissions/permissionsSlice';
import pStyles from './Permissions.module.css';

export default function TeamsManagersTab() {
    let dispatch = useDispatch()
    let teamsManagersList = useSelector((state) => state.permissions.teamsManagersList)

    let [expandedRows, setExpandedRows] = useState(null)
    let [globalFilter, setGlobalFilter] = useState('')

    useEffect(() => {
        dispatch(getTeamsManagersList({}))
    }, [dispatch])

    let managerCountTemplate = (rowData) => {
        return (
            <Tag
                value={rowData.manager_count || 0}
                severity={rowData.manager_count > 0 ? 'success' : 'danger'}
                style={{ fontSize: '0.8rem', minWidth: 30, textAlign: 'center' }}
            />
        )
    }

    let profileSeverity = (profileName) => {
        switch (profileName?.toLowerCase()) {
            case 'manager': return 'warning'
            case 'sdm': return 'info'
            case 'responscompte': return 'success'
            default: return 'warning'
        }
    }

    let rowExpansionTemplate = (data) => {
        if (!data.managers || !data.managers.length) {
            return (
                <div style={{ padding: '16px 24px', color: 'rgba(0,40,128,0.5)', fontStyle: 'italic' }}>
                    <Langs str="NO_MANAGERS_ASSIGNED" />
                </div>
            )
        }
        return (
            <div style={{ padding: '8px 24px' }}>
                <DataTable value={data.managers} size="small">
                    <Column
                        header={Localize('name')}
                        body={(row) => `${row.prenom} ${row.nom}`}
                        sortable
                        sortField="prenom"
                        style={{ minWidth: '12rem' }}
                    />
                    <Column field="email" header="Email" style={{ minWidth: '16rem' }} />
                    <Column
                        header={Localize('PROFILE')}
                        body={(row) => (
                            <Tag value={row.profile_name} severity={profileSeverity(row.profile_name)} />
                        )}
                        style={{ minWidth: '8rem' }}
                    />
                </DataTable>
            </div>
        )
    }

    let header = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 0' }}>
            <TextField
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder={Localize('SEARCH')}
                size="small"
                sx={{ width: 260 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ fontSize: 20, color: 'rgba(0,40,128,0.4)' }} />
                        </InputAdornment>
                    ),
                }}
            />
        </div>
    )

    return (
        <div className={`profile-mgmt-card ${pStyles.profileCard}`}>
            <div className={pStyles.infoBanner}>
                <InfoOutlinedIcon sx={{ fontSize: 18, color: 'rgba(0,40,128,0.5)' }} />
                <span><Langs str="TEAMS_OVERVIEW_INFO" /></span>
            </div>
            <DataTable
                value={teamsManagersList}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="id"
                header={header}
                globalFilter={globalFilter}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                emptyMessage={Localize('NO_RESULTS')}
                scrollable
                scrollHeight="calc(100vh - 380px)"
                style={{ borderRadius: 14, overflow: 'hidden' }}
            >
                <Column expander style={{ width: '3rem' }} />
                <Column field="name" header={Localize('TEAM')} sortable filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '12rem' }} />
                <Column field="client_name" header={Localize('CLIENT')} sortable filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '10rem' }} />
                <Column field="localization" header={Localize('LOCALIZATION')} sortable filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '10rem' }} />
                <Column field="manager_count" header={Localize('MANAGERS')} body={managerCountTemplate} sortable style={{ minWidth: '8rem' }} />
            </DataTable>
        </div>
    )
}
